import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
  theme,
} from "../../../utils/styles";

const appFooterStyles = {
  footer: {
    // marginTop: "25px",
    pt: 5,
    pb: 2,
    borderTop: "1px solid white",
    background: "#070530",
  },
  headTypo: {
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
  headBox: {
    display: "flex",
    alignItems: "center",
    height: "50px",
    borderBottom: "1px solid white",
    width: "fit-content",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
  contentTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    color: "#FFFFFF",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(-1),
    },
  },
  linkTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    color: "#FFFFFF",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(-1),
    },
  },
  footerTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(-1),
    color: "#FFFFFF",
  },
  footerSubTypo: {
    color: "#FFFFFF",
    cursor: "pointer",
    ...regularFont,
    "&:hover": {
      color: "#f15e22",
      transition: "all 0.5s ease",
      textShadow: "0 0 15px #f15e22",
    },
  },
  iconWrapper: {
    paddingTop: "7px",
    paddingLeft: "8px",
  },
  /** Fixed pill button — always on screen on mobile/tablet */
  floatingFooterTrigger: {
    position: "fixed" as const,
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1300,
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(135deg, rgba(144,83,246,0.92) 0%, rgba(75,1,80,0.92) 100%)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,0.18)",
    boxShadow:
      "0 4px 20px rgba(144,83,246,0.45), 0 0 0 1px rgba(144,83,246,0.2)",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:active": {
      transform: "translateX(-50%) scale(0.93)",
      boxShadow: "0 2px 10px rgba(144,83,246,0.35)",
    },
  },
  /** Bottom sheet drawer paper */
  footerDrawerPaper: {
    background: "#070530",
    borderTop: "1px solid rgba(144,83,246,0.35)",
    borderRadius: "20px 20px 0 0",
    maxHeight: "85vh",
    overflowY: "auto" as const,
  },
  /** Tap-to-close handle at top of drawer */
  drawerHandle: {
    display: "flex",
    justifyContent: "center",
    pt: 1.5,
    pb: 1,
    cursor: "pointer",
  },
  drawerHandleBar: {
    width: "40px",
    height: "4px",
    borderRadius: "999px",
    background:
      "linear-gradient(90deg, rgba(144,83,246,0.5), rgba(223,102,227,0.65), rgba(144,83,246,0.5))",
  },
  whiteBtnStyle: {
    py: 1,
    borderRadius: "8px",
    background: "#FDFDFD",
    color: "#000000",
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    minWidth: "130px",
    textShadow: "0 1px 0 rgb(0 0 0 / 40%)",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    willChange: "box-shadow,transform",

    "&:hover": {
      boxShadow:
        "0px 0.1em 0.2em rgb(45 35 66 / 40%), 0px 0.4em 0.7em -0.1em rgb(45 35 66 / 30%), inset 0px -3px 0px #9053F6",
      transform: "translateY(-0.1em)",
      background: "#FDFDFD",
      color: "#000000",
    },
  },
} as const;

export default appFooterStyles;
